import Vue from "vue";
import Vuex from "vuex";
import {
  SaveStatePlugin,
  LoadLang,
  LoadOrder,
  LoadInfo,
} from "./services/localstate";
import {
  GetCategories,
  GetDishes,
  GetBkg,
  GetInfo,
  GetLocations,
} from "./services/share";
import {
  Round2
} from "./services/helper";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [SaveStatePlugin],
  state: {
    lang: "",
    loc: [],
    cats: [],
    dishes: [],
    menubkg: "",
    info: {},
    order: {
      menu: "",
      total: 0,
      details: [],
    },
  },
  mutations: {
    initialiseStore(state) {
      state.lang = LoadLang();
    },
    SET_LANG(state, lang) {
      state.lang = lang;
    },
    LOAD_ORDER(state, id) {
      state.order = LoadOrder(id);
    },
    SET_CATEGORIES(state, cats) {
      state.cats = cats;
    },
    SET_LOCATIONS(state, loc) {
      state.loc = loc;
    },
    SET_DISHES(state, dishes) {
      state.dishes = dishes;
    },
    SET_BKG(state, file) {
      state.menubkg = file;
    },
    LOAD_INFO(state, id) {
      state.info = LoadInfo();
    },
    SET_INFO(state, data) {
      state.info.id = data.id;
      state.info.email = data.email;
      state.info.company = data.company;
      state.info.publicphone = data.public_phone;
      state.info.publicemail = data.public_email;
      state.info.shortphone = data.short_phone;
      state.info.activity = data.activity;
      state.info.delivery = data.delivery === "1";
      state.info.deliverytimefrom = data.delivery_time_from;
      state.info.deliverytimeto = data.delivery_time_to;
      state.info.paymentonline = data.payment_online === "1";
      state.info.paymentpos = data.payment_pos === "1";
      state.info.address = data.address;
      state.info.deliverytype = state.info.delivery ? 1 : 2;
      state.info.paymenttype = state.info.paymentonline ? 1 : 3;
    },
    ADD_TO_ORDER(state, item) {
      let idx = -1;
      if (state.order.details) {
        for (let index = 0; index < state.order.details.length; index++) {
          if (state.order.details[index].priceid === item.priceid) {
            idx = index;
            break;
          }
        }
      } else state.order.details = [];
      if (idx >= 0) {
        state.order.details[idx].count += item.count;
        state.order.details[idx].amount += item.amount;
      } else state.order.details.push(item);

      state.order.total = Round2(state.order.details.reduce((acc, val) => {
        return { amount: acc.amount + val.amount };
      }).amount);
    },

    REMOVE_ITEM(state, item) {
      state.order.details = state.order.details.filter(
        (c) => c.priceid !== item.priceid
      );
      if (state.order.details.length === 0) state.order.total = 0;
      else
        state.order.total = Round2(state.order.details.reduce((acc, val) => {
          return { amount: acc.amount + val.amount };
        }).amount);
    },

    UPDATE_ITEM_COUNT(state, item) {
      let idx = -1;
      if (state.order.details) {
        for (let index = 0; index < state.order.details.length; index++) {
          if (state.order.details[index].priceid === item.priceid) {
            idx = index;
            break;
          }
        }
      }
      state.order.details[idx].count = item.count;
      state.order.details[idx].amount = item.amount;

      state.order.total = Round2(state.order.details.reduce((acc, val) => {
        return { amount: acc.amount + val.amount };
      }).amount);
    },

    CLEAR_CART(state, id) {
      state.order = { menu: id, total: 0, details: [] };
    },
  },
  actions: {
    setLang({ commit }, lang) {
      commit("SET_LANG", lang);
    },

    fetchCategories({ commit, state }, id) {
      GetCategories(id, state.lang)
        .then((response) => {
          if (response.data.result)
            commit("SET_CATEGORIES", response.data.result);
          else console.log("There was an error:", response.data);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    fetchDishes({ commit, state }, id) {
      this.info = {};
      GetDishes(id, state.lang)
        .then((response) => {
          if (response.data.result) commit("SET_DISHES", response.data.result);
          else console.log("There was an error:", response.data);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    fetchMenuBkg({ commit }, id) {
      GetBkg(id)
        .then((response) => {
          if (response.data.result) commit("SET_BKG", response.data.result);
          else console.log("There was an error:", response.data);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    fetchInfo({ commit }, id) {
      return GetInfo(id)
        .then((response) => {
          if (response.data.result) {
            commit("SET_INFO", response.data.result);
          } else console.log("There was an error:", response.data);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    fetchLocations({ commit, state }, id) {
      GetLocations(id)
        .then((response) => {
          if (response.data.result)
            commit("SET_LOCATIONS", response.data.result);
          else console.log("There was an error:", response.data);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    clearCart({ commit }, id) {
      commit("CLEAR_CART", id);
    },

    addToOrder({ commit }, item) {
      commit("ADD_TO_ORDER", item);
    },

    updateItemCount({ commit }, item) {
      commit("UPDATE_ITEM_COUNT", item);
    },

    removeItem({ commit }, item) {
      commit("REMOVE_ITEM", item);
    },

    loadOrder({ commit }, id) {
      commit("LOAD_ORDER", id);
    },

    loadInfo({ commit }) {
      commit("LOAD_INFO");
    },
  },
  getters: {
    itemCountInOrder: (state) => (iid) => {
      let items = state.order.details.filter((c) => c.priceid === iid);
      if (items.length > 0)
        return items.reduce((acc, val) => {
          return { count: acc.count + val.count };
        }).count;
      else return 0;
    },
    orderTotal: (state) => {
      return state.order !== null ? state.order.total : 0;
    },
  },
});
